import {Component, Input, OnInit} from '@angular/core';
import {Profile} from '../../partner.model';
import {Model} from '../../../app.model';
import {CountryService} from '../../../country/country.service';
import {ProfileService} from '../../profile.service';
import {MessageService} from 'primeng/api';
import {Router} from '@angular/router';
import {Country} from "../../../country/country.model";
import {AutorunComponent} from "@myshared/autorun.component";
import {FormEmitter} from "../../../forms/form.component";

@Component({
    selector: 'app-profile-details',
    templateUrl: './profile-details.component.html',
    standalone: false
})
export class ProfileDetailsComponent extends AutorunComponent implements OnInit {
  @Input() public profile: Profile;

  public newLogo: string; // Data Uri if logo has changed
  public fileName: string;

  public countries: Country[];

  constructor(private countryService: CountryService,
              private profileService: ProfileService,
              private messageService: MessageService,
              private router: Router,
              private m: Model) {
    super();
  }

  ngOnInit() {
    this.autorun(() => {
      this.countries = this.m.country.countries;
    });

    this.countryService.refresh();
  }

  onSubmit(form: FormEmitter<Profile>) {
    const profile = form.data;
    this.profileService.save(profile).subscribe(
      () => {
        this.messageService.add({ severity: 'success', summary: 'Saved!', detail: '' });
        if (this.m.account.currentUser.company_website_profile === 'multiprofile') {
          this.router.navigate(['/partner', 'profiles']);
        }
    });
  }

  onDelete() {
    const cleanup = () => {
      this.messageService.add({ severity: 'success', summary: 'Deleted!', detail: '' });
      location.reload();
    };
    if (this.profile && this.profile.id) {
      this.profileService.deleteProfile(this.profile.id).subscribe(() => cleanup());
    } else {
      cleanup();
    }
  }

}
